import React from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import "core-js/features/array"; // polyfill for ie 11

import Site from "../Site/SiteContainer";
import Home from "../Home/Home";
import AppProvider from "./AppProvider";

const App = props => {
  const BASE_URLS = ["global.bible", "lvh.me", "localhost"];

  let hostname =
    process.env.REACT_APP_HOSTNAME_OVERRIDE ||
    props.hostname ||
    (document.location && document.location.hostname);

  if (BASE_URLS.includes(hostname)) {
    return <Home />;
  }

  return (
    <AppProvider>
      <Site hostname={hostname} />
    </AppProvider>
  );
};

App.propTypes = {
  hostname: PropTypes.string
};

App.defaultProps = {
  hostname: null
};

export default withRouter(App);
